import get from '@/ajax/product/get';
import getList from '@/ajax/product/getList';

/**
 * @module ajaxAPI/product
 *
 * @description
 * Ajax-обертки для работы с товарами
 */

const product = {
  get,
  getList
};

export default product;
